<template>
  <div class="px-3 py-2 row" v-if="modelValue?.payments?.length > 0">
    <div class="col-12">
      <h2>
        {{ $t("home.highRateOfFailedPaymentsInSomeCountries") }}
      </h2>
      <p>
        {{ $t("home.weHaveDetectedAnUnusuallyHighRateOfFailedPaymentsI") }}
      </p>
      <p>
        {{ $t("home.considerAddingLocalPaymentMethodsToCaterToRegional") }}
      </p>
    </div>
    <div
      class="row mt-3 col-6"
      v-for="payment in modelValue.payments"
      :key="payment.code"
    >
      <div class="col-4 bold-19">{{ payment.name }}</div>
      <div class="col-4 bold-19 text-danger">
        {{
          $t(`home.failed2`, {
            round: Math.round(payment.percent * 100),
          })
        }}
      </div>
      <div class="col-4 bold-19 text-danger">
        {{
          $t(`home.unsuccessfulPayments`, {
            round: Math.round(payment.failed * 0.94),
          })
        }}
      </div>
      <div class="col-4 align-self-center">
        {{
          $t(`home.mostPopularPaymentMethodsIn`, {
            name: payment.name,
          })
        }}
      </div>
      <div class="col-8 mt-3">
        <div
          v-for="method in payment.methods"
          :key="method.name"
          class="row mb-2 ms-1 ps-3 pe-4"
          :style="`background: linear-gradient(
                        90deg,
                        rgba(180, 96, 220, 0.1) 0%,
                        rgba(180, 96, 220, 0.1) ${method.popularity * 20}%,
                        rgba(180, 96, 220, 0) ${method.popularity * 20}%,
                        rgba(180, 96, 220, 0) 100%
                      );`"
        >
          <div class="col-8 pt-1 bold-14 text-gradient">
            {{ method.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="m-5 p-5 text-center regular-24">
    Everything is OK with the payments.
  </div>
</template>
<script>
export default {
  name: "PaymentsErrors",
  props: {
    key: Number,
    modelValue: Object,
  },
  data() {},
};
</script>
